import { deepPurple } from '@mui/material/colors';
import { Box, Card, Grid, Stack, useTheme, Typography } from '@mui/material';

import { useResponsive } from 'src/hooks/use-responsive';

export const QuizOnlineDetailFunctions = () => {
  const theme = useTheme();
  const deepPurpleColor = deepPurple.A200;

  const smDown = useResponsive('down', 'sm');
  const mdDown = useResponsive('down', 'md');
  const padding = () => {
    if (smDown) {
      return 2;
    }
    return 3;
  };
  return (
    <>
      <Stack my={5}>
        <Typography variant="h2" align="center">
          Học sinh làm bài trên cùng một nền tảng
        </Typography>
      </Stack>
      <Grid container maxWidth={1240} justifySelf="center" spacing={4}>
        <Grid md={6} sm={12} item>
          <Card
            sx={{
              maxWidth: 820,
              width: '100%',
              justifySelf: 'center',
              aspectRatio: !mdDown ? '1 / 0.94' : '',
              background: theme.palette.background.neutral,
              position: 'relative',
            }}
            variant="outlined"
          >
            <Stack justifyContent="space-between" height="100%">
              <Stack p={padding} zIndex={2}>
                <Typography variant="h5">Giao diện làm bài đơn giản, rõ ràng</Typography>
                <Typography variant="subtitle2" fontWeight={400}>
                  Dễ thao tác trên mọi thiết bị, đặc biệt tối ưu cho điện thoại – không cần cài đặt
                  thêm ứng dụng.
                </Typography>
              </Stack>
              <Stack>
                <Box
                  component="img"
                  alt="gradientbg4"
                  src="/assets/sub-pages/gradient4.png"
                  zIndex={1}
                  bottom={0}
                  left={30}
                  width="95%"
                  height={smDown ? '70%' : '88%'}
                  position="absolute"
                  sx={{ opacity: 0.2 }}
                />
              </Stack>
              <Stack>
                <Box
                  component="img"
                  alt="employee-detail"
                  src="/assets/sub-pages/lms/quiz-online/ui.png"
                  zIndex={2}
                  alignSelf="center"
                />
              </Stack>
            </Stack>
          </Card>
        </Grid>
        <Grid md={6} sm={12} item>
          <Card
            sx={{
              maxWidth: 820,
              width: '100%',
              justifySelf: 'center',
              aspectRatio: !mdDown ? '1 / 0.94' : '',
              background: theme.palette.background.neutral,
            }}
            variant="outlined"
          >
            <Stack justifyContent="space-between" height="100%">
              <Stack p={padding} zIndex={2}>
                {' '}
                <Typography variant="h5">Tạo nhanh câu hỏi với AI (Beta)</Typography>
                <Typography variant="subtitle2" fontWeight={400}>
                  Nhập chủ đề hoặc nội dung, hệ thống AI sẽ gợi ý câu hỏi, đáp án và giải thích.
                  Tiết kiệm thời gian biên soạn, phù hợp cả khi luyện tập lẫn tạo đề thi.
                </Typography>
              </Stack>
              <Stack>
                <Box
                  component="img"
                  alt="gradientbg8"
                  src="/assets/sub-pages/gradient8.png"
                  zIndex={1}
                  top={smDown ? 30 : -15}
                  left={-20}
                  height="95%"
                  position="absolute"
                  sx={{ opacity: 0.3 }}
                />
                <Box
                  component="img"
                  alt="gradientbg9"
                  src="/assets/sub-pages/gradient9.png"
                  zIndex={1}
                  position="absolute"
                  top={smDown ? 30 : -15}
                  height="90%"
                  right={-100}
                  sx={{ opacity: 0.3 }}
                />
              </Stack>
              <Stack>
                <Box
                  alignSelf="center"
                  alt="class-dashboard"
                  component="img"
                  src="/assets/sub-pages/lms/quiz-online/format.png"
                  zIndex={2}
                />
              </Stack>
            </Stack>
          </Card>
        </Grid>
        <Grid md={6} sm={12} item>
          <Card
            sx={{
              maxWidth: 820,
              width: '100%',
              justifySelf: 'center',
              aspectRatio: !mdDown ? '1 / 0.94' : '',
              background: theme.palette.background.neutral,
              position: 'relative',
            }}
            variant="outlined"
          >
            <Stack justifyContent="space-between" height="100%">
              <Stack p={padding} zIndex={2}>
                <Typography variant="h5">Tất cả hình thức bài tập & thi cử</Typography>
                <Typography variant="subtitle2" fontWeight={400}>
                  Phù hợp với tất cả hình thức bài tập & đề thi: Làm bài tại lớp - làm bài trực
                  tuyến hoặc tự làm bài ôn tập tại nhà.
                </Typography>
              </Stack>
              <Stack>
                <Box
                  component="img"
                  src="/assets/sub-pages/gradient10.png"
                  alt="gradientbg10"
                  zIndex={1}
                  bottom={-50}
                  left={-20}
                  height="92%"
                  position="absolute"
                  sx={{ opacity: 0.2 }}
                />
                <Box
                  component="img"
                  alt="gradientbg11"
                  src="/assets/sub-pages/gradient11.png"
                  zIndex={1}
                  position="absolute"
                  bottom={-40}
                  height="88%"
                  right={-100}
                  sx={{ opacity: 0.2 }}
                />
              </Stack>
              <Stack>
                <Box
                  component="img"
                  alt="employee-detail"
                  src="/assets/sub-pages/lms/quiz-online/notification.png"
                  zIndex={2}
                  width={0.95}
                  alignSelf="end"
                />
              </Stack>
            </Stack>
          </Card>
        </Grid>
        <Grid md={6} sm={12} item>
          <Card
            sx={{
              maxWidth: 820,
              width: '100%',
              justifySelf: 'center',
              aspectRatio: !mdDown ? '1 / 0.94' : '',
              background: theme.palette.background.neutral,
            }}
            variant="outlined"
          >
            <Stack justifyContent="space-between" height="100%">
              <Stack p={padding} zIndex={2}>
                {' '}
                <Typography variant="h5">Thông báo nhắc học sinh làm bài</Typography>
                <Typography variant="subtitle2" fontWeight={400}>
                  Tự động gửi thông báo khi có bài tập mới hoặc sắp hết hạn nộp – học sinh không bỏ
                  sót bài.
                </Typography>
              </Stack>
              <Stack>
                <Box
                  component="img"
                  alt="gradientbg8"
                  src="/assets/sub-pages/gradient8.png"
                  zIndex={1}
                  top={smDown ? 30 : -15}
                  left={-20}
                  height="95%"
                  position="absolute"
                  sx={{ opacity: 0.3 }}
                />
                <Box
                  component="img"
                  alt="gradientbg9"
                  src="/assets/sub-pages/gradient9.png"
                  zIndex={1}
                  position="absolute"
                  top={smDown ? 30 : -15}
                  height="90%"
                  right={-100}
                  sx={{ opacity: 0.3 }}
                />
              </Stack>
              <Stack>
                <Box
                  alignSelf="center"
                  alt="class-dashboard"
                  component="img"
                  src="/assets/sub-pages/lms/quiz-online/time-warning.png"
                  zIndex={2}
                />
              </Stack>
            </Stack>
          </Card>
        </Grid>
        <Grid md={6} sm={12} item>
          <Card
            sx={{
              maxWidth: 820,
              width: '100%',
              justifySelf: 'center',
              aspectRatio: !mdDown ? '1 / 0.95' : '',
              background: theme.palette.background.neutral,
            }}
            variant="outlined"
          >
            <Stack justifyContent="space-between" height="100%">
              <Stack p={padding} zIndex={2}>
                <Typography variant="h5">Hiển thị thời gian làm bài và cảnh báo hết giờ</Typography>
                <Typography variant="subtitle2" fontWeight={400}>
                  Linh hoạt thiết lập giới hạn thời gian theo phần và toàn bộ bài tập. Học sinh kiểm
                  soát thời gian trong bài kiểm tra.
                </Typography>
              </Stack>
              <Stack>
                <Box
                  component="img"
                  src="/assets/sub-pages/gradient10.png"
                  alt="gradientbg10"
                  zIndex={1}
                  bottom={-50}
                  left={-20}
                  height="92%"
                  position="absolute"
                  sx={{ opacity: 0.2 }}
                />
                <Box
                  component="img"
                  alt="gradientbg11"
                  src="/assets/sub-pages/gradient11.png"
                  zIndex={1}
                  position="absolute"
                  bottom={-40}
                  height="88%"
                  right={-100}
                  sx={{ opacity: 0.2 }}
                />
              </Stack>
              <Stack>
                <Box
                  component="img"
                  alt="class-task"
                  src="/assets/sub-pages/lms/quiz-online/auto-save.png"
                  zIndex={2}
                  alignSelf="center"
                />
              </Stack>
            </Stack>
          </Card>
        </Grid>
        <Grid md={6} sm={12} item>
          <Card
            sx={{
              maxWidth: 820,
              width: '100%',
              justifySelf: 'center',
              aspectRatio: !mdDown ? '1 / 0.95' : '',
              background: theme.palette.background.neutral,
            }}
            variant="outlined"
          >
            <Stack justifyContent="space-between" height="100%">
              <Stack p={padding} zIndex={2}>
                {' '}
                <Typography variant="h5">Tự động lưu tiến độ làm bài</Typography>
                <Typography variant="subtitle2" fontWeight={400}>
                  Học sinh có thể tạm dừng và làm tiếp mà không mất dữ liệu
                </Typography>
              </Stack>
              <Stack>
                <Box
                  component="img"
                  alt="gradientbg8"
                  src="/assets/sub-pages/gradient8.png"
                  zIndex={1}
                  top={smDown ? 30 : -15}
                  left={-20}
                  height="95%"
                  position="absolute"
                  sx={{ opacity: 0.3 }}
                />
                <Box
                  component="img"
                  alt="gradientbg9"
                  src="/assets/sub-pages/gradient9.png"
                  zIndex={1}
                  position="absolute"
                  top={smDown ? 30 : -15}
                  height="90%"
                  right={-100}
                  sx={{ opacity: 0.3 }}
                />
              </Stack>
              <Stack>
                <Box
                  component="img"
                  alt="class-schedule"
                  src="/assets/sub-pages/lms/quiz-online/redo.png"
                  zIndex={2}
                  alignSelf="center"
                />
              </Stack>
            </Stack>
          </Card>
        </Grid>
        <Grid md={6} sm={12} item>
          <Card
            sx={{
              maxWidth: 820,
              width: '100%',
              justifySelf: 'center',
              aspectRatio: !mdDown ? '1 / 0.9' : '',
              background: theme.palette.background.neutral,
            }}
            variant="outlined"
          >
            <Stack justifyContent="space-between" height="100%">
              <Stack p={padding} zIndex={2}>
                <Typography variant="h5">Lưu trữ vào thư viện riêng và tái sử dụng</Typography>
                <Typography variant="subtitle2" fontWeight={400}>
                  Tự tạo và quản lý ngân hàng câu hỏi riêng của Trung tâm bạn, bảo mật và phục vụ
                  tái sử dụng cho từng bài tập, chương trình học hoặc từng lớp hợp.
                </Typography>
              </Stack>{' '}
              <Stack>
                <Box
                  component="img"
                  alt="gradientbg8"
                  src="/assets/sub-pages/gradient8.png"
                  zIndex={1}
                  top={smDown ? 30 : -15}
                  left={-20}
                  height="95%"
                  position="absolute"
                  sx={{ opacity: 0.3 }}
                />
                <Box
                  component="img"
                  alt="gradientbg9"
                  src="/assets/sub-pages/gradient9.png"
                  zIndex={1}
                  position="absolute"
                  top={smDown ? 30 : -15}
                  height="90%"
                  right={-100}
                  sx={{ opacity: 0.3 }}
                />
              </Stack>
              <Stack width="100%">
                <Box
                  alt="class-assignment"
                  component="img"
                  src="/assets/sub-pages/lms/quiz-online/result.png"
                  zIndex={2}
                  alignSelf="center"
                />
              </Stack>
            </Stack>
          </Card>
        </Grid>
        <Grid md={6} sm={12} item>
          <Card
            sx={{
              maxWidth: 820,
              width: '100%',
              justifySelf: 'center',
              aspectRatio: !mdDown ? '1 / 0.9' : '',
              background: theme.palette.background.neutral,
            }}
            variant="outlined"
          >
            <Stack justifyContent="space-between" height="100%">
              <Stack p={padding} zIndex={2}>
                <Typography variant="h5">Ngân hàng bài tập chuẩn hóa của CenterUp</Typography>
                <Typography variant="subtitle2" fontWeight={400}>
                  Sử dụng ngân hàng câu hỏi, bài tập & đề thi đã chuẩn hóa của CenterUp, được xây
                  dựng dựa trên các bộ giáo trình uy tín từ các nhà xuất bản nổi tiếng.
                </Typography>
              </Stack>{' '}
              <Stack>
                <Stack>
                  <Box
                    component="img"
                    src="/assets/sub-pages/gradient10.png"
                    alt="gradientbg10"
                    zIndex={1}
                    bottom={-50}
                    left={-20}
                    height="92%"
                    position="absolute"
                    sx={{ opacity: 0.2 }}
                  />
                  <Box
                    component="img"
                    alt="gradientbg11"
                    src="/assets/sub-pages/gradient11.png"
                    zIndex={1}
                    position="absolute"
                    bottom={-40}
                    height="88%"
                    right={-100}
                    sx={{ opacity: 0.2 }}
                  />
                </Stack>
                <Stack width="100%">
                  <Box
                    alt="teacher-wordsheet"
                    component="img"
                    src="/assets/sub-pages/lms/quiz-online/process.png"
                    zIndex={2}
                    width={0.95}
                    alignSelf="center"
                  />
                </Stack>
              </Stack>
            </Stack>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};
